import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import StatusPill from "./common/StatusPill";
import { useLocation } from "react-router-dom";
import UpdateActionPopUp from "./common/UpdateActionPopUp";

const FORMDATA = {
  actionId: "1",
  siteName: "a",
  buildingName: "a",
  siteAddress: "a",
  postCode: "a",
  country: "UK",
  actionReq: "a",
  elementAffected: "a",
  dueDate: "1",
  insData: "1",
  insBy: "ak",
  appon: "2",
  appby: "r",
  statush: "High",
  statusp: "Pending",
};
const ViewAction = () => {
  const { clientNameParam } = useParams();

  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedRow = state?.selectedRow;

  const { userObj } = useSelector((state) => state.user);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [formData, setFormData] = useState(FORMDATA);
  console.error(setFormData);
  useEffect(() => {
    if (!userObj || !userObj?.token) {
      navigate(
        generatePath("/client/:clientNameParam", {
          clientNameParam,
        }),
        { replace: true, state: { from: "/ViewAction" } },
      );
    }
  }, [userObj, navigate]);

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB", {
      month: "long",
      day: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    if (!selectedRow) return;
    setFormData({
      siteName: selectedRow.siteName ?? "",
      buildingName: selectedRow.buildingName ?? "",
      siteAddress: selectedRow.address ?? "",
      postCode: selectedRow.postalcode ?? "",
      // country: selectedRow.country ?? "",
      country: "UK",
      actionReq: selectedRow.actionRequired ?? "",
      elementAffected: selectedRow.elementAffected ?? "",
      // dueDate: selectedRow.dueDate?.split("T")[0] ?? "",
      // insData: selectedRow.inspctiondate?.split("T")[0] ?? "",
      dueDate: formatDate(selectedRow.dueDate),
      insData: formatDate(selectedRow.inspctiondate),

      insBy: selectedRow.inspectionby ?? "",
      // appon: selectedRow.approvedon?.split("T")[0] ?? "",
      appon: formatDate(selectedRow.approvedon),
      appby: selectedRow.approveby ?? "",
      statush: selectedRow.priority ?? "",
      statusp: selectedRow.status ?? "",
      compcheckid: selectedRow.complianceCheckid ?? "",
      inspdoorid: selectedRow.inspectedDoorid ?? "",
      comcheckmaster: selectedRow.complianceCheckMasterid ?? "",
      actionId: selectedRow.actionId ?? "",
      gaps: selectedRow.gaps ?? "",
    });
  }, [selectedRow]);

  const selectedRows = selectedRow
    ? [
        {
          compcheckid: selectedRow.compcheckid,
          inspdoorid: selectedRow.inspdoorid,
          comcheckmaster: selectedRow.comcheckmaster,
          gaps: selectedRow.gaps,
        },
      ]
    : [];

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="dashboard_header">
              <div className="d-flex justify-content-between align-items-center mt-2">
                <div>
                  <h2 className="mb-0">View Action</h2>
                  <p className="header-description mb-0">
                    View and update inspection information
                  </p>
                </div>
                {formData?.statusp === "Pending" && (
                  <button
                    type="button"
                    className="btn btn-dark fw-bold"
                    onClick={() => setShowUpdateModal(true)}
                  >
                    <i className="fa fa-edit me-2"></i>
                    Update Action(s)
                  </button>
                )}
                {showUpdateModal && (
                  <UpdateActionPopUp
                    show={showUpdateModal}
                    headingText="Update Action(s)"
                    cancelText="Cancel"
                    submitText="Update"
                    selectedRows={selectedRows}
                    onCancel={() => {
                      setShowUpdateModal(false);
                    }}
                    // onSuccess={() => {
                    //   setShowUpdateModal(false);
                    // }}

                    onSuccess={(updatedData) => {
                      setShowUpdateModal(false);

                      setFormData((prev) => ({
                        ...prev,
                        statusp: updatedData.status,
                        appby: updatedData.completedBy,
                        appon: updatedData.completedOn,
                      }));
                    }}
                  />
                )}
              </div>
              <div className="resident-card d-flex flex-column gap-2 mt-3 text-start shadow">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="resident-card-header mb-0">
                    Inspection Details
                  </h3>
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <StatusPill status={formData.statush} />
                    <StatusPill status={formData.statusp} />
                  </div>
                </div>

                <div className="card-body-section mt-1">
                  <div className="form-group">
                    <label htmlFor="id">ID</label>
                    <input
                      className="form"
                      name="id"
                      placeholder="Enter Id"
                      aria-label="Floating label select example"
                      value={formData.actionId}
                      disabled={true}
                    ></input>
                  </div>
                  <div className="form-group">
                    <label htmlFor="sitename">Site Name</label>
                    <input
                      className="form"
                      name="sitename"
                      placeholder="Enter site name"
                      aria-label="Floating label select example"
                      value={formData.siteName}
                      disabled={true}
                    ></input>
                  </div>
                </div>
                <div className="card-body-section mt-1">
                  <div className="form-group">
                    <label htmlFor="sitename">Building Name</label>
                    <input
                      className="form"
                      name="buildingName"
                      placeholder="Enter site name"
                      aria-label="Floating label select example"
                      value={formData.buildingName}
                      disabled={true}
                    ></input>
                  </div>
                  <div className="form-group">
                    <label htmlFor="siteAddress">Site Address</label>
                    <input
                      className="form"
                      name="siteAddress"
                      id="siteAddress"
                      placeholder="Enter site address"
                      aria-label="Floating label select example"
                      value={formData.siteAddress}
                      disabled={true}
                    ></input>
                  </div>
                </div>
                <div className="card-body-section mt-1">
                  <div className="form-group">
                    <label htmlFor="postCode">Post Code</label>
                    <input
                      className="form"
                      name="postCode"
                      placeholder="Enter post code"
                      aria-label="Floating label select example"
                      value={formData.postCode}
                      disabled={true}
                    ></input>
                  </div>
                  <div className="form-group">
                    <label htmlFor="city">Country</label>
                    <input
                      className="form"
                      name="city"
                      placeholder="Enter city"
                      aria-label="Floating label select example"
                      value={formData.country}
                      disabled={true}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="resident-card d-flex flex-column gap-2 mt-3 text-start  shadow">
                <h3 className="resident-card-header">Action Details</h3>
                <div className="form-group">
                  <label className="fw-semibold mb-2">Action Required</label>

                  <textarea
                    className="action-box"
                    value={formData.actionReq}
                    disabled
                  />
                </div>

                <div className="card-body-section mt-1">
                  <div className="form-group">
                    <label htmlFor="element Affected">Element Affected</label>
                    <input
                      className="form"
                      name="element Affected"
                      placeholder="Element Affected"
                      aria-label="Floating label select example"
                      value={formData.elementAffected}
                      disabled={true}
                    ></input>
                  </div>
                  <div className="form-group">
                    <label htmlFor="Due Date">Due Date</label>
                    <input
                      className="form"
                      name="Due Date"
                      placeholder="Enter due date"
                      aria-label="Floating label select example"
                      value={formData.dueDate}
                      disabled={true}
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            <div className="resident-card d-flex flex-column gap-2 mt-3  mb-4 text-start  shadow">
              <h3 className="resident-card-header">Inspection Timeline</h3>

              <div className="card-body-section mt-1">
                <div className="form-group">
                  <label htmlFor="inspectionDate">Inspection Date</label>
                  <input
                    className="form"
                    name="inspectionDate"
                    placeholder="Enter Id"
                    aria-label="Floating label select example"
                    value={formData.insData}
                  ></input>
                </div>
                <div className="form-group">
                  <label htmlFor="inspectedBy">Inspected By</label>
                  <input
                    className="form"
                    name="inspectedBy"
                    placeholder="Enter site name"
                    aria-label="Floating label select example"
                    value={formData.insBy}
                    disabled={true}
                  ></input>
                </div>
              </div>
              <div className="card-body-section mt-1">
                <div className="form-group">
                  <label htmlFor="postCode">Approved By </label>
                  <input
                    className="form"
                    name="postCode"
                    // placeholder="Enter post code"
                    aria-label="Floating label select example"
                    // value="Akhil Singh"
                    value={formData.appby}
                    disabled={true}
                  ></input>
                </div>
                <div className="form-group">
                  <label htmlFor="city">Approved On </label>
                  <input
                    className="form"
                    name="city"
                    // placeholder="Enter city"
                    aria-label="Floating label select example"
                    // value="25 October 2025"
                    value={formData.appon}
                    disabled={true}
                  ></input>
                </div>
              </div>
            </div>
            <div className="button-container text-end">
              <button
                type="button"
                className="btn-secondary col-sm-5 col-md-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewAction;
